<template>
    <div class="ProductItem" data-cy="product-item" v-html="processedSource"></div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
    name: "ProductItem",
    props: {
        source: {
            type: String,
            required: true
        }
    },
    computed: {
        processedSource() {
            const div = document.createElement("div");
            div.innerHTML = this.source;
            div.childNodes.forEach(node => {
                if (node.nodeType == Node.TEXT_NODE) {
                    node.parentNode?.removeChild(node);
                }
            });

            div.firstChild?.replaceWith(...div.firstChild.childNodes);
            return div.innerHTML;
        }
    }
});
</script>
